export default {
    name: 'MaintenHistory',
    data() {
        return {
            Model: {},
            Consumables: []
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            var result = await this.$api.getMaintenHistory(this.$route.params.id);
            this.Model = result.Model;
            this.Consumables = result.Consumables;

            var cols = [
                {
                    title: "序號",
                    data: "Index",
                    width: 100
                },
                {
                    title: "保養確認",
                    data: "IsFinish",
                    render(data, type, row, meta) {
                        var check = '';
                        if (data) {
                            check = 'checked="checked"';
                        }
                        return `<label class="control control--checkbox">
                        <input type="checkbox" ${check}>
                        <div class="control__indicator"></div>
                      </label>`;
                    }
                }, {
                    title: "保養項目",
                    data: "Name"
                },
                {
                    title: "保養人",
                    data: "Account"
                },
                {
                    title: "完成保養時間",
                    data: "Account",
                    render: window.filters.dateTimeFormat
                },
            ];
            this.createDataTable('#tableData', cols, this.Model.Items, { bSort: false, searching: false });

            setTimeout(() => {
                this.toDataTable('.consumable-data', { bSort: false, searching: false, paging: false });
            }, 1000);
        },
        goback(){
            window.history.go(-1);
        }
    }
}